import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'IncludePipe'
})
@Injectable()

export class IncludePipe  implements PipeTransform {
 transform(items: any[], field: string, value: string, reverse?:boolean): any[] {
     
   if (!items) return [];
   if (!value) return [];
   return items.filter(it => 
    {
      var chk = false;
      for(var i=0; i < value.split(',').length; i++)
        {
        if(it[field] == value.split(',')[i])
            chk = true;
        }
      if(reverse)
        return !chk
      else
        return chk
    })
 }
}